// extracted by mini-css-extract-plugin
export default {"deletedUnit":"deletedUnit---R0uZ_"};